import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { salesDatasService } from "services/salesData.api";
import { selectSalesDataItems } from "store/salesDataSlice";
import { setSalesDataItems } from "store/salesDataSlice";

const useSalesData = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const salesDataList = useSelector(selectSalesDataItems);
  const [error, setError] = useState(null);

  const getsalesDataList = async (data) => {
    setLoading(true);
    try {
      const response = await salesDatasService.fetchList(data);
      if (response.success) {
        dispatch(setSalesDataItems(response));
      }
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const salesDataPreview = async (payload) => {
    setLoading(true);
    try {
      const response = await salesDatasService.previewSalesDatas(payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const salesDataSync = async (payload) => {
    setLoading(true);
    try {
      const response = await salesDatasService.syncSalesDatas(payload);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  const deletePurchase = async (id) => {
    setLoading(true);
    try {
      const response = await salesDatasService.deletePurchase(id);
      setLoading(false);
      return response;
    } catch (err) {
      setLoading(false);
      setError(err);
      return err;
    }
  };

  return {
    getsalesDataList,
    salesDataList,
    salesDataPreview,
    salesDataSync,
    loading,
    error,
    deletePurchase,
  };
};

export default useSalesData;
